import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/userLogin/revoke/userLogin.revoke.mutation.gql"
import type {
  UserLoginRevokeMutation,
  UserLoginRevokeMutationVariables,
} from "@/v2-backoffice-client/userLogin/revoke/__types__/userLogin.revoke.mutation"

type Options = MutationHookOptions<
  UserLoginRevokeMutation,
  UserLoginRevokeMutationVariables
>

export function useUserLoginRevokeMutation(options?: Options) {
  return useMutation<UserLoginRevokeMutation, UserLoginRevokeMutationVariables>(
    mutation,
    options,
  )
}
